// extracted by mini-css-extract-plugin
export var body = "IRpNSVnxlz1vZEswqBwb";
export var hero = "JRV9OKFIiZL2N1RBorWA";
export var large = "UWfIFLlVySs0wTfnHyWR";
export var micro = "oAmha7pN7AVCo2i7H1hz";
export var mini = "pFmVTUiJ8mKkyvM5oH7I";
export var small = "Os1R23UNJOx5IpibAI8A";
export var title1 = "a63EwS_oeGMFmxnrOieH";
export var title2 = "Dv7eniosTY3xZ3Am8NKx";
export var title3 = "JrRtukHypcr6j6nfJIBr";